import SVGA from 'svgaplayerweb'

const initSVGA = (id, src) => new Promise((resolve, reject) => {
  const player = new SVGA.Player(`#${id}`)
  const parser = new SVGA.Parser(`#${id}`)
  parser.load(src, function (videoItem) {
    player.setVideoItem(videoItem)
    player.startAnimation()
    resolve({player, videoItem})
  }, function (error) {
    reject(error)
  })
})

const createCanvas = (parent, id, width, height, is2x = false) => {
  if (document.querySelector(`#${id}`)){
    return  id
  }
  const canvas = document.createElement('canvas')
  canvas.width = width || parent.clientWidth
  canvas.height = height || parent.clientHeight
  canvas.id = id
  canvas.style = `position: absolute;top: 0;left: 0;z-index: 2;`
  if (is2x){
    canvas.classList.add('canvas-2x')
  }
  parent.appendChild(canvas)
  return id
};

export const initCanvas = (selectors, src, width, height, canvasId, is2x) => {
  const e = document.querySelector(selectors)
  const id = createCanvas(e, canvasId || 'canvas', width, height, is2x)
  if (src){
    return initSVGA(id, src)
  }
};

export const initCanvas2x = (selectors, src, width, height, canvasId) => {
  return initCanvas(selectors, src, width * 2, height * 2, canvasId, true)
}
